<template>
	<div class="display-flex gap-50">
		<BaseLink
			v-for="social in socialProfilesDisplay"
			:key="social.url"
			:link="{ href: social.url, target: '_blank' }"
		>
			<div class="social-profile__logo-border">
				<img :src="social.icon?.url" :alt="`${social.linkText} logo`" class="social-profile__logo" />
			</div>
		</BaseLink>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { SanityProxyLink } from 'types/sanity';

interface Props {
	socialProfiles: Array<SanityProxyLink>;
}

const props = defineProps<Props>();

const socialProfilesDisplay = computed((): Array<SanityProxyLink> => {
	return props.socialProfiles.filter((s) => !!s.icon);
});
</script>

<style lang="scss" scoped>
@use '../../../styles/constants/_colors.scss' as *;
@use '../../../styles/utilities/respond-to.scss' as *;

$lg-start: 1200px;
.social-profile {
	&__logo {
		width: 24px;
		height: 24px;
		padding: 2px;

		@include respond-to(lg) {
			padding: 0px;
		}
	}

	&__logo-border {
		@media screen and (max-width: $lg-start - 1) {
			border-radius: 100px;
			border: 1px solid token('bg-tertiary');
			display: flex;
			width: 36px;
			height: 36px;
			justify-content: center;
			align-items: center;
			gap: 4px;
		}
	}
}
</style>
